import { Box, Grid, Typography } from "@mui/material";
import AppCard from "../../../../components/ui/AppCard";
import Eyebrow from "../../../../components/ui/Eyebrow";

export default function ProductDescription(props) {
    const {
        public_description,
        category_name,
        format_name,
        confort_name,
        height,
        width,
        length,
        thickness,
        plating_name,
        finishing_name,
        clasp_type_name,
        high_gold_weight,
        low_gold_weight,
        silver_weight
    } = props;

    const listaDescricao = [
        { label: "Descrição", value: public_description },
        { label: "Categoria", value: category_name },
        { label: "Formato", value: format_name },
        { label: "Conforto", value: confort_name },
        { label: "Altura", value: height + 'mm' },
        { label: "Largura", value: width + 'mm' },
        { label: "Comprimento", value: length + 'mm' },
        { label: "Espessura", value: thickness + 'mm' },
        { label: "Banho", value: plating_name },
        { label: "Acabamento", value: finishing_name },
        { label: "Tipo de Fecho", value: clasp_type_name },
        { label: "Peso em ouro 18K", value: high_gold_weight + 'g' },
        { label: "Peso em ouro 10K", value: low_gold_weight + 'g' },
        { label: "Peso em Prata 950", value: silver_weight + 'g' },
    ];

    const listaFiltrada = listaDescricao
        .slice(1)
        .filter(item => item.value && item.value !== "0.00" && item.value !== "0" && item.value !== "0.00mm");

    return (
        <Grid size={12}>
            <AppCard>
                {listaDescricao[0].value && (
                    <Typography sx={styles.description}>
                        {listaDescricao[0].value}
                    </Typography>
                )}

                <Eyebrow sx={{ mb: 1 }}>Ficha técnica</Eyebrow>

                <Box sx={styles.specList}>
                    {listaFiltrada.map((item, index) => (
                        <Box key={index} sx={styles.specRow}>
                            <Typography component="span" sx={styles.specLabel}>{item.label}</Typography>
                            <Typography component="span" sx={styles.specValue}>{item.value}</Typography>
                        </Box>
                    ))}
                </Box>
            </AppCard>
        </Grid>
    );
}

const styles = {
    description: {
        textAlign: 'left',
        color: 'text.primary',
        mb: '1.5rem',
    },
    specList: {
        display: 'flex',
        flexDirection: 'column',
    },
    specRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: '1rem',
        py: '.6rem',
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-of-type': { borderBottom: 'none' },
    },
    specLabel: {
        color: 'text.secondary',
        fontSize: '.9rem',
    },
    specValue: {
        color: 'text.primary',
        fontWeight: 600,
        fontSize: '.9rem',
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums',
    },
};
